import gql from 'graphql-tag'

export const GET_LAST_LR = gql`
query getLastLR($startDate:timestamptz!){
  lr(where: {created_at: {_gte: $startDate}}, order_by: {created_at: desc}, limit: 1) {
      lrNumber
  }
}
`
export const GET_LR_BY_ID = gql`
query getLRById($id:uuid!){
  lr(where: {id: {_eq: $id}}) {
      id
      pickupAddressId
      dropAddressId
      lrNumber
      consignorId
      consigneeId
      PickupAddress {id addressLine1 addressLine2 area city state pincode}
      DropAddress {id addressLine1 addressLine2 area city state pincode}
      pickupCompanyId
      dropCompanyId
      transportVehicle
      status
  }
}
`
